import { Component, Injectable } from '@angular/core';
import { NavController, NavParams, ViewController, App } from 'ionic-angular';
import { Globals } from '../../../../globals';


/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-popup-errors',
  templateUrl: 'popup-errors.html',
})
@Injectable({
  providedIn: 'root'
})

export class PopupErrorsPage {
  title: any;
  origin: any;
  msg: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals,
    public app: App) {
    this.title = this.navParams.get('title');
    this.origin = this.navParams.get('origin');
    this.msg = this.navParams.get('msg');
  }

  close() {

    if(this.origin != 'tpv-error-caja'){
      this.viewCtrl.dismiss();
    } else {
      let data = { 'close': true };
      this.viewCtrl.dismiss(data);
    }
  }

  changeCash() {
    let data = { 'open_change_cash': true };
    this.viewCtrl.dismiss(data);
  }

  alegraClose() {
    let data = { 'close': true };
    this.viewCtrl.dismiss(data);
  }

  changeTakeawayCustomer() {
    let data = { 'open_change_tk_customer': true };
    this.viewCtrl.dismiss(data);
  }

}


// WEBPACK FOOTER //
// ./src/pages/components/popups/popup-errors/popup-errors.ts